import React, { useState, useEffect } from 'react';
import * as classnames from 'classnames';

import { Arrow } from '../../static';
import SelectItem from './Item';

import './styles.scss';

const Select = ({optionsList = [], defaultText = 'Default Text',id = 'id', value}) => {

	const [defaultSelectText, setDefaultSelectText] = useState(() => defaultText)
    const [showOptionList, setShowOptionList] = useState(false)
    const [checkedText, setCheckedText] = useState(false)

    const handleListDisplay = () => {
        setShowOptionList(prevState => !prevState)
    };

    const handleOptionClick = e => {
        setDefaultSelectText(e.target.getAttribute("data-name"));
		value && value( {id, value: e.target.getAttribute("data-name")} );
		setShowOptionList(false);
	};

	useEffect(() => {
		if(defaultText !== defaultSelectText) {
			setCheckedText(true);
		};
	},[defaultSelectText,defaultText]);
	
	return (
		<div className="select">
		  	<div
				className={classnames('select__text',{
					'select__text--active': showOptionList,
					'select__text--checked': checkedText
				})}
				onClick={handleListDisplay}
		  	>
				{defaultSelectText}
				<div 
					className={classnames('select__icon',{
						'select__icon--active': showOptionList
					})}
				>
					<Arrow />
				</div>
			</div>
			<ul 
				className={classnames('select__options',{
					'select__options--active': showOptionList
				})}
			>
				{optionsList.map((option,i) => (
				<SelectItem 
					key={i}
					option={option} 
					handleOptionClick={handleOptionClick}
				/>
				))}
			</ul>
		</div>
	);
};

export default Select;
